var $ = require('../internals/export');

var parseFloat = require('../internals/parse-float'); // `Number.parseFloat` method
// https://tc39.github.io/ecma262/#sec-number.parseFloat


$({
  target: 'Number',
  stat: true,
  forced: Number.parseFloat != parseFloat
}, {
  parseFloat: parseFloat
});